const { Swiper } =
  await import(`./swiper-core.js?v=${Date.now()}`);
const { Mousewheel, Pagination } =
  await import(`./pagination.js?v=${Date.now()}`);
import "./create-element-if-not-defined.js";
class mediaSlider extends HTMLElement {
  constructor() {
    super();
    if (window.innerWidth < 768) {
      const swiperContainer = this.querySelector(".swiper");
      const options = {
        modules: [Mousewheel, Pagination],
        slidesPerView: "auto",
        mouseWheel: true,
        pagination: {
          el: ".swiper-pagination"
        }
      };
      new Swiper(swiperContainer, options);
    }
  }
}
if (customElements.get("media-slider") === void 0) {
  customElements.define("media-slider", mediaSlider);
}
